<template>
  <div class="d-flex m-3 gap-2">

    <!-- Main Content -->
    <div class="w-75 d-flex flex-column gap-3">
      <div class="mb-2 card border-0 p-3 shadow-sm w-100">
        <h4>Checkbox</h4>
        <p class="text-gray-600">Use checkboxes to select single or multiple options from a list.</p>
        
        <h5 class="mt-4 mb-2">How to Import</h5>
        <p class="text-gray-600">To import the Checkbox component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2">npm install</code>
      </div>

      <CheckboxOverview />

      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-4 mt-2">Props</h4>
        <b-table striped bordered :items="items" :fields="fields"></b-table>

        <h6 class="mb-4 mt-4">Include the following objects in the array for <strong class="text-danger">option prop</strong> to display specific info</h6>
        <b-table striped bordered :items="arrays" :fields="fieldsArray"></b-table>       
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxOverview from '@/components/local/Checkbox/CheckboxOverview'

export default {
  components: { CheckboxOverview },
  data () {
    return {
      components: [
        { name: 'Buttons', link: 'buttons' },
        { name: 'Checkbox', link: 'checkbox' },
      ],

      fields: [
        { key: 'prop', tdClass: 'setAmountTdClass' },
        { key: 'type', tdClass: 'setAmountTdClass' },
        { key: 'default', tdClass: 'setAmountTdClass' },
        { key: 'description' }
      ],

      fieldsArray: [
        { key: 'object', tdClass: 'setAmountTdClass' },
        { key: 'type', tdClass: 'setAmountTdClass' },
        { key: 'description' }
      ],

      items: [
          { prop: 'id', type: 'String', default: 'null', description: 'Used to set the id attribute on the rendered content, and used as the base to generate any additional element IDs as needed' },
          { prop: 'name', type: 'String', default: 'null', description: 'Sets the value of the name attribute on the form control' },
          { prop: 'value', type: 'String', default: 'null', description: 'Value returned when this checkbox is checked' },
          { prop: 'option', type: 'Array', default: 'null', description: 'Array of items to render in the component' },
          { prop: 'text', type: 'String', default: 'null', description: 'Text beside the checkbox' },
          { prop: 'size', type: 'String', default: 'md', description: "Set the size of the component's appearance. 'sm', 'md' (default), or 'lg'" },
          { prop: 'indeterminate', type: 'Boolean', default: 'false', description: 'Used in multi selection of checkboxes. For visual display only.' },
          { prop: 'true-value', type: 'Boolean, String', default: 'true', description: 'Custom true value of a checkbox' },
          { prop: 'false-value', type: 'Boolean, String', default: 'false', description: 'Custom false value of a checkbox' },
          { prop: 'disabled', type: 'Boolean', default: 'false', description: "When set to true, disables the component's functionality and places it in a disabled state" },
          { prop: 'inline', type: 'Boolean', default: 'false', description: 'When set to true, renders the checkboxes in inline mode' },
      ],

      arrays: [
          { object: 'text', type: 'String', description: 'Text beside the checkbox' },
          { object: 'value', type: 'String', description: 'Value of the checkbox when selected' },
          { object: 'disabled', type: 'Boolean', description: "When set to true, disables the component's functionality and places it in a disabled state" },
      ],
    }
  },

  methods: {
    setAmountTdClass() {
        return 'code-text'
    }
  }
}
</script>

<style>
.code-text {
  font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono" ,"Courier New", monospace;
  color: red!important;
}
</style>